import "./RelatedSearchByTagContentProductStyles.scss";
import $ from "jquery";
import { applyHoverZoomEffectWrapper } from "../FunctionsCore";
const relatedSearchByTagContentProduct = (relatedSearchByTagContentProductParameter) => {
    $(() => applyHoverZoomEffectWrapper(relatedSearchByTagContentProductParameter.applyHoverZoomEffectWrapperParameter));
};
export { relatedSearchByTagContentProduct };
